
		<div class="amplify-component">
			<ng-template component-host></ng-template>
		</div>
	